<template>
  <v-card class="card-pad pa-6 text-center">
    <v-btn absolute top right small @click="$emit('close')" icon text>
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <h3><strong>Escolha do template</strong></h3>
    <div class="my-4">
      <span class="text--caption">
        Escolha o template que você usará em sua checklist de rotina de
        inspeção.
      </span>
    </div>

    <v-form ref="form">
      <v-autocomplete
        :items="templates"
        v-model="templateId"
        :rules="[(v) => !!v || 'Template é obrigatório!']"
        item-text="name"
        item-value="id"
        dense
        class="primary-input"
        placeholder="Template de checklist"
        outlined
        append-icon="mdi-chevron-down"
      ></v-autocomplete>
    </v-form>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button"
        depressed
        @click="submit"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
export default {
  name: 'InspectionRoutineModal',

  props: {
    serviceOrderId: {
      type: Number,
      default: () => {},
    },
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getTemplates()
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      institutionId: '',
      templates: [],
      templateLoading: false,
      templateId: null,
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const model = {
          serviceOrderId: this.serviceOrderId,
          institutionId: this.institutionId,
          templateId: this.templateId,
        }

        this.apiService
          .post(`inspectionRoutineChecklist/add`, model)
          .then((response) => {
            this.$router.push(
              `/inspectionRoutineChecklist/manage?id=${response.entityId}`
            )
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },

    getTemplates() {
      this.templateLoading = true

      this.apiService
        .get(
          `InspectionRoutineChecklistTemplate/forOrder/${this.serviceOrderId}`
        )
        .then((response) => {
          this.templates = response.content
          this.templateLoading = false
        })
        .catch(() => {
          this.templateLoading = false
        })
    },
  },
}
</script>

<style></style>
